import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const ImageCarousel = ({ slides = [], interval = 10000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Move to next slide
  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  // Move to previous slide
  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  // Auto advance slides
  useEffect(() => {
    if (slides.length === 0) return;

    const timer = setInterval(nextSlide, interval);
    return () => clearInterval(timer);
  }, [slides.length, interval, nextSlide]);
    // Safety guard
    if (!slides || slides.length === 0) {
      return null;
    }

  const currentSlide = slides[currentIndex];

  return (
    <div className="carousel-container">

      <button className="prev-button" onClick={prevSlide}>
        &#10094;
      </button>

      <div className="carousel-slide">

        {slides.map((slide, index) => (
          <div
            key={slide.public_id || index}
            className="carousel-item"
            style={{
              opacity: index === currentIndex ? 1 : 0,
              transition: "opacity 1s ease-in-out",
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img
              src={slide.url}
              alt={slide.description || ""}
              style={{
                maxWidth: "95%",
                maxHeight: "95%",
                objectFit: "contain"
              }}
            />
          </div>
        ))}

      </div>

      <button className="next-button" onClick={nextSlide}>
        &#10095;
      </button>

      <div className="carousel-description">
        <p>
          {currentSlide.description} |{" "}
          <Link to={`/collections/${currentSlide.collection}`}>
            {currentSlide.collection} Collection
          </Link>
        </p>
      </div>

    </div>
  );
};

export default ImageCarousel;